import { Injectable } from "@angular/core";
import { AngularFirestore } from "angularfire2/firestore";
import * as firebase from "firebase/app";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import * as moment from "moment";

@Injectable({
  providedIn: "root",
})
export class AdminService {
  ref = firebase.firestore().collection("users");
  private leadManagementCollection: any;
  private roleCollection: any;
  private linkClientCollection: any;

  constructor(
    private firestore: AngularFirestore,
    public afs: AngularFirestore,
    private httpService: HttpClient
  ) {
    this.leadManagementCollection = this.afs.collection<any>(
      "leadmanagement",
      (ref) => ref.orderBy("corpName")
    );
    this.linkClientCollection = this.afs.collection<any>("linkclients", (ref) =>
      ref.orderBy("corpName")
    );
  }

  generateUniqNumber() {
    var length = 8,
      charset = "0123456789",
      retVal = "";
    for (var i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  addLinkClient(data: any) {
    data["timeStamp"] = moment().format("x");
    return this.linkClientCollection.add(data);
  }

  addFaq(data: any) {
    data["timeStamp"] = moment().format("x");
    return firebase.firestore().collection("faqList").add(data);
  }

  getAllFaqs() {
    return new Promise((resolve) => {
      this.firestore
        .collection("faqList", (ref) => ref.orderBy("createdAt", "desc"))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAllLinkedClients() {
    return new Promise((resolve) => {
      this.firestore
        .collection("linkclients", (ref) => ref.orderBy("createdAt", "desc"))
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLinkedClientById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("linkclients").doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  updateClient(data: any) {
    data["timeStamp"] = moment().format("x");
    return this.afs.doc<any>("linkclients/" + data.id).set(data);
  }

  updateLead(data: any) {
    data["timeStamp"] = moment().format("x");
    return this.afs.doc<any>("leadmanagement/" + data.id).set(data);
  }

  addNewLead(data: any) {
    data["timeStamp"] = moment().format("x");
    return this.leadManagementCollection.add(data);
  }

  getLeadById(uid: any) {
    return new Promise((resolve) => {
      var docRef = this.firestore.collection("leadmanagement").doc(uid);

      docRef.ref
        .get()
        .then(function (doc) {
          if (doc.exists) {
            let res = { ...doc.data(), id: doc.id };
            resolve(res);
          }
        })
        .catch(function (error) {
          resolve(null);
        });
    });
  }

  getLiveLead() {
    return new Promise((resolve) => {
      this.firestore
        .collection("leadmanagement", (ref) =>
          ref.where("status", "==", "On-Boarding Completed")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLeadByHotelCorpId(hotelId: any, corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection("leadmanagement", (ref) =>
          ref
            .where("hotelId", "==", hotelId)
            .where("corpId", "==", corpId)
            .where("status", "==", "On-Boarding Completed")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getAllLeads() {
    return new Promise((resolve) => {
      this.firestore
        .collection("leadmanagement")
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLeadByHotelId(hotelId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection("leadmanagement", (ref) =>
          ref.where("hotelId", "==", hotelId).orderBy("timeStamp", "desc")
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  getLeadByCorpId(corpId: any) {
    return new Promise((resolve) => {
      this.firestore
        .collection("leadmanagement", (ref) =>
          ref.where("corpId", "==", corpId)
        )
        .snapshotChanges()
        .subscribe((users) => {
          let contactList = users.map((item) => {
            return {
              ...(item.payload.doc.data() as {}),
              id: item.payload.doc.id,
            };
          });
          resolve(contactList);
        });
    });
  }

  // ========================== Mock Services ========================================

  getJsonLeadMangementData() {
    return this.httpService.get("../../assets/data/json-lead-management.json");
  }

  getJsonLinkClientData() {
    return this.httpService.get("../../assets/data/json-link-client.json");
  }

  getJsonAcquisitionData() {
    return this.httpService.get(
      "../../assets/data/json-admin-acquisition-report.json"
    );
  }

  getJsonCityWiseAcquisitionData() {
    return this.httpService.get(
      "../../assets/data/json-admin-city-wise-acquisition-report.json"
    );
  }

  getJsonMonthWiseAcquisitionData() {
    return this.httpService.get(
      "../../assets/data/json-admin-month-wise-acquisition-report.json"
    );
  }

  getJsonCommissionData() {
    return this.httpService.get(
      "../../assets/data/json-admin-commissions-report.json"
    );
  }

  getJsonHotelUsersData() {
    return this.httpService.get(
      "../../assets/data/json-admin-hotel-user-report.json"
    );
  }

  getJsonCorpUsersData() {
    return this.httpService.get(
      "../../assets/data/json-admin-corporate-user-report.json"
    );
  }

  getJsonChurnClientsData() {
    return this.httpService.get(
      "../../assets/data/json-admin-client-churn-report.json"
    );
  }

  getJsonTransactionReportData() {
    return this.httpService.get(
      "../../assets/data/json-admin-client-transaction-report.json"
    );
  }

  getJsonExpenseVolReportData() {
    return this.httpService.get(
      "../../assets/data/json-admin-expense-volume-report.json"
    );
  }

  getJsonRevenueVolReportData() {
    return this.httpService.get(
      "../../assets/data/json-admin-revenue-volume-report.json"
    );
  }

  getJsonBlockedCorpReportData() {
    return this.httpService.get(
      "../../assets/data/json-admin-blocked-corporate-report.json"
    );
  }

  getJsonViewSubscriptionData() {
    return this.httpService.get(
      "../../assets/data/json-admin-view-subscription.json"
    );
  }
}
